import styled from "@emotion/styled";
import { useEffect, useRef } from "react";
import { Trans } from "react-i18next";
import { useTranslation } from "react-i18next";
import { ExternalLink } from "../shared/Icon";
import {
  SectionContent,
  SectionHeading,
  SectionSmallHeading,
} from "../shared/Section";
import splitText from "../shared/splitText";

const Lastests = styled.div`
  display: flex;
  margin-top: auto;
  gap: 1.5rem;
  & > div {
    width: 240px;
  }
  @media (${(props) => props.theme.breakpoint}) {
    flex-direction: column;
    & > div {
      width: 100%;
    }
  }
`;

const List = styled.ul`
  list-style: none;
  li {
    margin-bottom: 0.4rem;
    opacity: 0.7;
  }
`;

const ListItemNumber = styled.span`
  margin-right: 1rem;
`;

const ListItemDate = styled.span`
  display: inline-block;
  min-width: 120px;
  margin-right: 1rem;
`;

const Links = styled.ul`
  list-style: none;
  display: flex;
  gap: 0.5rem;
`;

const Link = styled.a`
  display: flex;
  align-items: center;
  margin-left: 0.5rem;
  @media (${(props) => props.theme.breakpoint}) {
    margin-right: 0.5rem;
    margin-left: 0;
  }
  text-decoration: none;
  color: #fff;
  opacity: 0.7;
  line-height: 0.7rem;
  &:hover {
    opacity: 1;
  }
  svg {
    width: 0.7rem;
    height: 0.7rem;
    margin-left: 0.3rem;
  }
`;

const rewards = [
  {
    label: "CSSDesignAwards - Kudo",
    amount: 1,
  },
  {
    label: "CSSDesignAwards - UI Award",
    amount: 1,
  },
  {
    label: "CSSDesignAwards - UX Award",
    amount: 1,
  },
  {
    label: "CSSDesignAwards - Innovation",
    amount: 1,
  },
];

const collaborations = [
  {
    label: "Storyfox",
    dates: "06/2021 - unknown",
  },
  {
    label: "Cikaba",
    dates: "08/2021 - unknown",
  },
  {
    label: "Becoms",
    dates: "07/2021 - 08/2021",
  },
];

const Skills = ({ visible }) => {
  const { t } = useTranslation();
  const heading = useRef();

  useEffect(() => {
    if (heading) {
      splitText(heading.current);
    }
  }, [heading]);

  return (
    <SectionContent
      align="right"
      height={"60vh"}
      className={visible ? "section-content active" : "section-content"}
    >
      <SectionHeading textAlign="right" ref={heading}>
        <Trans i18nKey={"Contact.title"}>
          Wanna work together ?<br />
          Let’s <strong>talk</strong> about it
        </Trans>
      </SectionHeading>
      <Links>
        <Link
          href="mailto:hello@dorianguilmain.com"
          target="_blank"
          rel="noreferrer"
        >
          Email <ExternalLink />
        </Link>
        <Link
          href="https://www.linkedin.com/in/dorian-guilmain"
          target="_blank"
          rel="noreferrer"
        >
          LinkedIn <ExternalLink />
        </Link>
        <Link
          href="https://twitter.com/dorianguilmain"
          target="_blank"
          rel="noreferrer"
        >
          Twitter <ExternalLink />
        </Link>
        <Link
          href="https://www.malt.fr/profile/dorianguilmain"
          target="_blank"
          rel="noreferrer"
        >
          Malt <ExternalLink />
        </Link>
      </Links>
      <Lastests>
        <div>
          <SectionSmallHeading>
            {t("Contact.lastCollaborations")}
          </SectionSmallHeading>
          <List>
            {collaborations.map((collaboration, index) => (
              <li key={index}>
                <ListItemDate>{collaboration.dates}</ListItemDate>
                {collaboration.label}
              </li>
            ))}
          </List>
        </div>
        <div>
          <SectionSmallHeading>{t("Contact.lastRewards")}</SectionSmallHeading>
          <List>
            {rewards.map((reward, index) => (
              <li key={index}>
                <ListItemNumber>{`0${reward.amount}`}</ListItemNumber>
                {reward.label}
              </li>
            ))}
          </List>
        </div>
      </Lastests>
    </SectionContent>
  );
};

export default Skills;
